var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aco-grid"},[_c('div',{staticClass:"aco-info-box"},[_c('event-filter')],1),_c('div',{staticClass:"aco-details-box"},[_c('event-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }